var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M7.35069 1.24676L7.35127 1.2463C8.17916 0.582215 9.53227 0.583593 10.3782 1.25637C10.3783 1.25651 10.3785 1.25665 10.3787 1.25679L16.0807 5.81261C16.3573 6.0388 16.613 6.40799 16.7812 6.84777C16.9493 7.28696 17.0057 7.73287 16.9524 8.086L15.8564 14.6363C15.8563 14.637 15.8561 14.6377 15.856 14.6384C15.6641 15.7352 14.5794 16.651 13.4766 16.651H4.2424C3.12028 16.651 2.06362 15.7595 1.87182 14.648C1.87174 14.6475 1.87165 14.647 1.87156 14.6465L0.774465 8.08951L0.774173 8.08779C0.713908 7.73268 0.766256 7.28664 0.933595 6.84838C1.10089 6.41022 1.35948 6.04176 1.64335 5.81556L1.64466 5.81452L7.35069 1.24676Z",
    stroke: "#8B8F92",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27055 13.4777C8.91338 13.4777 8.61719 13.1819 8.61719 12.8252V10.215C8.61719 9.85832 8.91338 9.5625 9.27055 9.5625C9.62772 9.5625 9.92391 9.85832 9.92391 10.215V12.8252C9.92391 13.1819 9.62772 13.4777 9.27055 13.4777Z",
    fill: "#8B8F92",
    stroke: "#8B8F92",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.631af977133ad3607a6243ccf29ab55e.svg";
export { ForwardRef as ReactComponent };